<i18n>
  {
    "en": {
      "unit": {
        "businessHours": "businessHours",
        "day": "day",
        "week": "week",
        "month": "month",
        "year": "year"
      }
    },
    "zh-tw": {
      "unit": {
        "businessHours": "營業時段",
        "day": "日",
        "week": "週",
        "month": "月",
        "year": "年"
      }
    }
  }
</i18n>

<template v-if="storeHotSale">
  <f7-page>
    <f7-navbar title="報表查詢結果" back-link="back" />
    <div style="display: flex;">
      <f7-button
        @click="outputExcel"
        raised
        fill
        style="display: flex; justify-content: center; margin: .5rem .5rem .5rem auto; ">
        下載報表
      </f7-button>
    </div>
    <div class="wrap">
      <div class="card data-table" style="position: static; box-shadow: none; margin-left: 60px" >
        <table>
          <thead>
            <tr>
              <th class="label-cell headCol" style="padding-right: 0px" >{{ searchUnitCh }}</th>
              <th class="label-cell" v-for="(storeHotSale, key) in storeHotSaleReport" :key="`header2-${key}`"> {{ getDateCell(storeHotSale.startDateString) }} </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in getStoreHotSaleReportMax" :key="`header2-${key}`">
              <td class="label-cell headCol">{{ item }}</td>
              <td class="label-cell" v-for="(storeHotSale, index) in storeHotSaleReport" :key="`storeHotSale2-${index}`">
                {{ storeHotSale.rows.length > key ? `${storeHotSale.rows[key].title}(${storeHotSale.rows[key].count} - ${hotSalePercentage[index][key]})` : 'N/A' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
import shortid from 'shortid'

export default {
  dependencies: ['themeColor'],
  data () {
    return {
    }
  },
  methods: {
    getDateCell (value) { // 若是 day week 日期顯示為 YYYY-MM-DD 若是 month 顯示為 YYYY-MM 若是 year 顯示格式 YYYY
      if (this.searchUnit === 'day' || this.searchUnit === 'week') {
        return value
      } else if (this.searchUnit === 'month') {
        return moment(value).format('YYYY-MM')
      } else if (this.searchUnit === 'year') {
        return moment(value).format('YYYY')
      }
    },
    outputData () {
      let result = []
      for (let key = 0; key < this.getStoreHotSaleReportMax; key++) {
        let row = [key + 1]
        this.storeHotSaleReport.forEach((storeHotSale, index) => {
          let cell = storeHotSale.rows.length > key ? `${storeHotSale.rows[key].title}(${storeHotSale.rows[key].count} - ${this.hotSalePercentage[index][key]})` : 'N/A'
          row.push(cell)
        })
        result.push(row)
      }
      return result
    },
    outputExcel () {
      let resultData = []
      let titles = []
      titles.push(`時間(${this.searchUnitCh})`)
      let dateTitles = this.storeHotSaleReport.map(storeHotSale => {
        let dateCell = this.getDateCell(storeHotSale.startDateString)
        return dateCell.includes('-') ? dateCell : `-${this.getDateCell(storeHotSale.startDateString)}-`
      })
      titles = titles.concat(dateTitles)

      this.outputData().forEach(element => {
        let row = {}
        element.forEach((data, index) => {
          row[titles[index]] = data
        })
        resultData.push(row)
      })
      const ws = XLSX.utils.json_to_sheet(resultData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'People')
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })
      FileSaver.saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), `${shortid.generate()}.xlsx`)
    },
    s2ab (s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
      return buf
    }
  },
  computed: {
    ...mapState('statisticsModule', ['storeHotSale', 'searchUnit']),
    ...mapGetters('statisticsModule', ['storeHotSaleReport']),
    ...mapState(['store', 'tableNumbers']),
    searchUnitCh () { // 把 search 轉成中文
      switch (this.searchUnit) {
        case 'day':
          return '日'
        case 'week':
          return '週'
        case 'month':
          return '月'
        case 'year':
          return '年'
      }
    },
    getStoreHotSaleReportMax () { // 取得銷售排行最大數量
      return this.storeHotSaleReport.reduce((prev, item, index) => Math.max(prev, item.rows.length), 0)
    },
    hotSalePercentage () {
      return this.storeHotSaleReport.map((storeHotSale) => {
        if (storeHotSale.rows.length > 0) {
          const total = storeHotSale.rows.reduce((prev, next) => {
            return Number(prev) + Number(next.count)
          }, 0)
          return storeHotSale.rows.map(row => {
            let num = (row.count) / total // 計算該物品總數除上全部總數
            num = Math.round(num * 1000) / 1000 // 取至小數點後第一位
            num = Number(num * 1000) / 10
            return num + '%'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
th, td {
  white-space: nowrap;
}

#time-label.label-cell, #time-interval.label-cell {
  padding: 0px 0px 0px 16px;
}

.wrap {
  margin: 10px;
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,.2), 0px 1px 1px 0px rgba(0,0,0,.14), 0px 1px 3px 0px rgba(0,0,0,.12);
}

.headCol {
  position: absolute;
  width: auto;
  left: 15px;
  top: auto;
  display: flex;
  align-items: center;
}

.headerCol:before {
  display: none;
}

</style>
